import { Calendar } from 'lucide-react'

// Toggle "todas as datas": desliga o filtro de data sem apagar o valor selecionado.
export default function DateFilterToggle({ value, onChange, allDates, onToggleAllDates }) {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center gap-2">
        <Calendar className="w-5 h-5 text-gray-400" />
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={allDates}
          className="border-0 focus:ring-0 text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
        />
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          role="switch"
          aria-checked={allDates}
          onClick={() => onToggleAllDates(!allDates)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            allDates ? 'bg-primary-600' : 'bg-gray-300'
          }`}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              allDates ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
        <span className="text-sm text-gray-600">Todas as datas</span>
      </div>
    </div>
  )
}
